import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { ArrowDownIcon, IconFillColor, IconWrapper } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.prescription';

import { MedicineReplacementFormBean, MedicineReplacementFormController } from './MedicineReplacementForm.types';
import { StyledForm } from './MedicineReplacementForm.styled';
import { WithdrawnMedicineField } from './fields/WithdrawnMedicineField';
import { NewMedicineField } from './fields/newMedicine/NewMedicineField';

type MedicineReplacementFormRenderProps = Pick<MedicineReplacementFormController, 'handleSubmit' | 'formState'> & {
   newMedicineSelected: boolean;
};

type MedicineReplacementFormProps = {
   withdrawnMedicine: MedicineSimple;
   children: (renderProps: MedicineReplacementFormRenderProps) => JSX.Element;
   patientId: Patient['id'];
   visitDiagnoses: VisitDiagnoses;
};

export const MedicineReplacementForm = (props: MedicineReplacementFormProps): JSX.Element => {
   const controller = useFormController<MedicineReplacementFormBean>({
      withdrawnMedicine: props.withdrawnMedicine,
      newMedicine: null,
      searchText: null,
   });

   const { newMedicine } = controller.watch();
   const newMedicineSelected = Boolean(newMedicine);

   return (
      <>
         <StyledForm $gap={newMedicineSelected ? '4px' : '18px'}>
            <WithdrawnMedicineField register={controller.register} />
            {newMedicineSelected ? (
               <IconWrapper testId={'arrowDown'} fillColor={IconFillColor.PRIMARY}>
                  <ArrowDownIcon />
               </IconWrapper>
            ) : null}
            <NewMedicineField
               register={controller.register}
               control={controller.control}
               setValue={controller.setValue}
               patientId={props.patientId}
               visitDiagnoses={props.visitDiagnoses}
               withdrawnMedicineId={props.withdrawnMedicine.id}
            />
         </StyledForm>
         {props.children({
            formState: controller.formState,
            handleSubmit: controller.handleSubmit,
            newMedicineSelected: newMedicineSelected,
         })}
      </>
   );
};
